import { urlJoin } from './url-utils';
import { general, urlAuth } from '../settings';

export default {
    ROOT: `${process.env.PUBLIC_URL}/`,
    LOGIN: uri =>
        `${urlAuth}/authorize?client_id=${general.client_id}&redirect_uri=${uri}&response_type=code&scope=ead-admin`,
    LOGOUT: uri =>
        `${urlAuth}/logout?client_id=${general.client_id}&redirect_uri=${uri}`,
    HOME: `${process.env.PUBLIC_URL}/admin/classes`,
    ADMIN: `${process.env.PUBLIC_URL}/admin`,
    COURSES: `${process.env.PUBLIC_URL}/admin/courses`,
    CLASSES: `${process.env.PUBLIC_URL}/admin/classes`,
    TCCS: `${process.env.PUBLIC_URL}/admin/tccs`,
    USERS: `${process.env.PUBLIC_URL}/admin/users`,
    GLOBAL: `${process.env.PUBLIC_URL}/admin/global`,
    TRAINERS: `${process.env.PUBLIC_URL}/admin/trainers`,
    ADMINS: `${process.env.PUBLIC_URL}/admin/admins`,
    COURSE_RESOURCES: (...ids) =>
        urlJoin(`${process.env.PUBLIC_URL}/admin/courses`, ...ids),
    CLASS_RESOURCES: (...ids) =>
        urlJoin(`${process.env.PUBLIC_URL}/admin/classes`, ...ids),
    QUESTIONS_DATABASE: `${process.env.PUBLIC_URL}/admin/online-tests/questions`,
    TEMPLATE_TESTS: `${process.env.PUBLIC_URL}/admin/online-tests/template-tests`,
    PERFORMED_TESTS: `${process.env.PUBLIC_URL}/admin/online-tests/performed-tests`,
    ADD_QUESTION: `${process.env.PUBLIC_URL}/admin/online-tests/questions/add-question`,
    DUPLICATE_QUESTION: `${process.env.PUBLIC_URL}/admin/online-tests/questions/:question_id/duplicate`,
    MANAGE_QUESTION: `${process.env.PUBLIC_URL}/admin/online-tests/questions/:question_id/manage-question`,
    DUPLICATE_TEMPLATE_TEST: `${process.env.PUBLIC_URL}/admin/online-tests/template-tests/:test_id/duplicate`,
    MANAGE_TEMPLATE_TEST: `${process.env.PUBLIC_URL}/admin/online-tests/template-tests/:test_id/manage-template-test`,
    ADD_TEMPLATE_TEST: `${process.env.PUBLIC_URL}/admin/online-tests/template-tests/add`,
};



// WEBPACK FOOTER //
// ./src/utils/routes.js